import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _blogTag = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _categoryWithTranslations = { coverImage: '_commonImage' };
var _commonImage = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _coverMedia = { image: '_commonImage', video: '_video' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getPostFeedMetadataPageRequest = {};
var _getPostFeedMetadataPageResponse = {
    postFeedMetadataPage: '_postFeedMetadataPage',
};
var _getPostFeedPageRequest = {};
var _getPostFeedPageResponse = { postFeedPage: '_postFeedPage' };
var _media = { wixMedia: '_wixMedia' };
var _metrics = { averageRating: 'FLOAT' };
var _moderationDetails = {
    submittedDate: 'google.protobuf.Timestamp',
    moderationDate: 'google.protobuf.Timestamp',
};
var _post = {
    firstPublishedDate: 'google.protobuf.Timestamp',
    lastPublishedDate: 'google.protobuf.Timestamp',
    coverMedia: '_coverMedia',
    heroImage: '_commonImage',
    metrics: '_metrics',
    moderationDetails: '_moderationDetails',
    media: '_media',
};
var _postFeedMetadataPage = { postMetrics: 'Map#_metrics' };
var _postFeedPage = {
    posts: '_posts',
    categories: '_categoryWithTranslations',
    tags: '_blogTag',
};
var _posts = { posts: '_post' };
var _video = { thumbnail: '_commonImage' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_commonImage',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_commonImage',
};
var _wixMedia = { image: '_commonImage', videoV2: '_videoV2' };
function resolveComWixpressNpmBlogFrontendAdapterPublicV2PostFeedPageServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns a page of feed data. */
export function getPostFeedPage(payload) {
    var _a = serializer(_getPostFeedPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostFeedPageResponse, {
        _blogTag: _blogTag,
        _categoryWithTranslations: _categoryWithTranslations,
        _commonImage: _commonImage,
        _coverMedia: _coverMedia,
        _focalPoint: _focalPoint,
        _media: _media,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _post: _post,
        _postFeedPage: _postFeedPage,
        _posts: _posts,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getPostFeedPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.post_feed_page',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.PostFeedPageService.GetPostFeedPage',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2PostFeedPageServiceUrl({ protoPath: '/v2/post-feed-page', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostFeedPage.fromReq = fromReq;
    __getPostFeedPage.__isAmbassador = true;
    return __getPostFeedPage;
}
/** Returns a page of feed metadata. */
export function getPostFeedMetadataPage(payload) {
    var _a = serializer(_getPostFeedMetadataPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostFeedMetadataPageResponse, {
        _metrics: _metrics,
        _postFeedMetadataPage: _postFeedMetadataPage,
    }).fromJSON;
    function __getPostFeedMetadataPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.post_feed_page',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.PostFeedPageService.GetPostFeedMetadataPage',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2PostFeedPageServiceUrl({ protoPath: '/v2/post-feed-page-metadata', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostFeedMetadataPage.fromReq = fromReq;
    __getPostFeedMetadataPage.__isAmbassador = true;
    return __getPostFeedMetadataPage;
}
//# sourceMappingURL=http.impl.js.map